import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateRangePickerComponent } from './date-range-picker.component';
import { TranslateModule } from '@ngx-translate/core';
import { FlexModule } from '@angular/flex-layout';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [DateRangePickerComponent],
  imports: [CommonModule, TranslateModule, FlexModule, NgbDatepickerModule],
  exports: [DateRangePickerComponent],
})
export class DateRangePickerModule {}
